module.exports = "/images/vendor/flag-icon-css/flags/1x1/be.svg?f1e78c8b3266b110a4a523c4cde8d7f2";